// pages/account.tsx
import * as React from "react";
import { PageParamsProvider as PageParamsProvider__ } from "@plasmicapp/react-web/lib/host";
import GlobalContextsProvider from "../components/plasmic/inventory/PlasmicGlobalContextsProvider";
import { PlasmicAccount } from "../components/plasmic/inventory/PlasmicAccount";
import { useRouter } from "next/router";
import { createImmutableStateInvariantMiddleware } from '@reduxjs/toolkit'
console.log("The type of createImmutableStateInvariantMiddleware is", typeof createImmutableStateInvariantMiddleware)
// --- MODIFIED THIS SECTION ---
import { GetServerSidePropsContext } from 'next';
import { createPagesRouteClient } from '../lib/supabase/server';
export async function getServerSideProps(context: GetServerSidePropsContext) {
  const supabase = createPagesRouteClient(context);
  const { data: { user } } = await supabase.auth.getUser();

  // The new, smarter redirect condition:
  // ONLY redirect a logged-in user if they land on /account WITHOUT a specific error query param.
  // This allows the middleware to send unauthorized (but logged-in) users here
  // to see an error or log out, breaking the redirect loop.
  if (user && !context.query.error) {
    return {
       props: {},
    };
  }

  

  // In all other cases (no user, or a user with an error param), render the page.
  return {
    props: {},
  };
}
// --- END OF MODIFIED SECTION ---


function Account() {
  return (
    <GlobalContextsProvider>
      <PageParamsProvider__
        route={useRouter()?.pathname}
        params={useRouter()?.query}
        query={useRouter()?.query}
      >
        <PlasmicAccount />
      </PageParamsProvider__>
    </GlobalContextsProvider>
  );
}

export default Account;